import { useContext, useState } from "react";
import Dashboardmain from "../dashboardmain";
import Addkeyword from "../../../modals/addkeywordModal";
import Addpreset from "../../../modals/addpresetModal";
import "./style.css";
import ReactDocViewer from "./ReactDocViewer";
import { useNavigate } from "react-router-dom";
import { uploadFilesAPI } from "../../../APIs/API";
import { MyContext } from "../../../MyContext/MyProvider";
import { getEmail } from "../../../utils/utils";

const Fileclassification = (props) => {
  const { setProcessedFiles } = useContext(MyContext);
  const [isaddModalOpen, setIsaddModalOpen] = useState(false);
  const [isremoveModalOpen, setisremoveModalOpen] = useState(false);
  const navigate = useNavigate();

  const handleFile = async (files) => {
    const fileArray = Array.from(files);
    try {
      const email = getEmail();
      const res = await uploadFilesAPI({ files: fileArray, email });
      setProcessedFiles((prevFiles) => [...prevFiles, ...res]);
    } catch (error) {
      console.error("File upload failed", error);
    }
  };

  const handleChange = (e) => {
    e.preventDefault();
    if (e.target.files && e.target.files.length > 0) {
      handleFile(e.target.files);
    }
  };
  return (
    <>
      <div className={`  ${props.hide} `}>
        <Dashboardmain />
      </div>
      <div className="fileclassification-main-container h-center v-center flex-column w-100">
        <div className={` keywords-div d-flex gap-3 ${props.hide} `}>
          <label
            onClick={() => navigate("/findings")}
            className="large keyword-selected fw-medium text-white v-center h-center cursor-pointer"
          >
            Continue
          </label>
        </div>

        <ReactDocViewer />
      </div>
      <Addkeyword
        isaddModalOpen={isaddModalOpen}
        setIsaddModalOpen={setIsaddModalOpen}
      />
      <Addpreset
        isremoveModalOpen={isremoveModalOpen}
        setisremoveModalOpen={setisremoveModalOpen}
      />
    </>
  );
};

export default Fileclassification;
